import React from "react";

const WebCounter = () => {
  return (
    <div className="flex justify-center items-center p-4">
    <span className="text-lg font-semibold mb-2 text-white">Page Views  </span>
      <a href="https://www.hitwebcounter.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://hitwebcounter.com/counter/counter.php?page=19065043&style=0036&nbdigits=6&type=page&initCount=0"
          title="Counter"
          alt="Web Counter"
        />
      </a>
    </div>
  );
};

export default WebCounter;